const revokeObjectUrl = (url: string) => {
  // The download click is handled asynchronously by the browser, so revoking the
  // object URL immediately can cancel the file before the download starts.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 100);
};

export function downloadBlob(blob: Blob, fileName = 'download'): void {
  const blobUrl = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  revokeObjectUrl(blobUrl);
}

export async function downloadFileFromUrl(url: string, fileName?: string): Promise<void> {
  try {
    // Skip the HTTP cache. Chrome caches the <audio> response without CORS, and a
    // later fetch of the same URL then fails, so download does nothing after playback.
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error('Failed to fetch file');

    const blob = await response.blob();
    downloadBlob(blob, fileName || 'download');
  } catch (error) {
    console.error('Download failed:', error);
  }
}
